<script lang="ts" setup>
type TagType = 'tables' | 'explore' | 'marketplace' | 'comingSoon'

interface IProps {
  is?: string
  mainText: string
  subtitle: string
  tagType: TagType
  hoverClass?: string
}

const props = defineProps<IProps>()

const { colors } = useTheme()

const bgColor = computed(() => colors.elemental[props.tagType]?.bg || '#ffffff')
const textColor = computed(() => colors.elemental[props.tagType]?.color || '#000000')
const isScriptReady = ref(false)

const title = computed(() => ({
  explore: 'Explore',
  marketplace: 'Marketplace',
  comingSoon: 'Coming Soon',
  tables: 'Tables',
}[props.tagType] || 'Tables'))

onMounted(() => {
  isScriptReady.value = true
})
</script>

<template>
  <component v-bind="$props" :is="is ?? 'div'" class="group" :class="[hoverClass]">
    <TextV2
      class="inline-flex max-w-max text-[14px] font-bold p-1 pr-2 pl-1 gap-1.5 rounded-5 mb-3"
      :class="tagType === 'comingSoon' ? 'pl-2' : ''"
      :style="{ color: textColor, backgroundColor: bgColor }"
    >
      <span
        v-if="tagType !== 'comingSoon'" class="flex items-center justify-center rounded-5"
        :style="{ color: textColor, backgroundColor: bgColor }"
      >
        <IconTable v-if="tagType === 'tables'" w-6 />
        <IconExplorer v-else-if="tagType === 'explore'" w-6 />
        <IconMarketplace v-else-if="tagType === 'marketplace'" w-6 />
      </span>
      {{ title }}
    </TextV2>

    <div class="flex flex-col gap-1">
      <TextV2 class="text-[14px]">
        {{ subtitle }}
      </TextV2>
      <TextV2 class="text-[20px] font-bold">
        <span v-html="mainText" />
      </TextV2>
    </div>

    <div class="overflow-x-hidden mt-2">
      <div class="transition-all duration-300 ease-in-out group-hover:ml-0" :class="{ 'ml-[-24px]': isScriptReady }">
        <AppPlaceholder v-if="!isScriptReady" class="w-[50px] h-6" variant="gradient" />
        <IconForward v-else />
      </div>
    </div>
  </component>
</template>

<style scoped>
.group {
  @apply flex flex-col p-4 md:px-7 gap-1.5 md:gap-2.5 min-h-[220px] min-w-[220px] rounded-5 border-1 transition-colors transition-shadow text-left;
}

.group:active {
  @apply active:bg-grayLighter;
}
</style>
